import { SET_CONTROLS } from "../actions/controls";

const initialState = {  
    volume : 80
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CONTROLS : {
            return {...action.action}
        }
      default:
        return state;
    }
  }
  